import React from 'react';

const TrashIcon = (props) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M6 7H18L17.0663 20.0712C17.029 20.5946 16.5935 21 16.0689 21H7.93112C7.40648 21 6.97104 20.5946 6.93366 20.0712L6 7Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M19 5C19 4.44772 18.5523 4 18 4H15.5L14.5 3H9.5L8.5 4H6C5.44772 4 5 4.44772 5 5C5 5.55228 5.44772 6 6 6H18C18.5523 6 19 5.55228 19 5Z" fill="currentColor" />
  </svg>
);

export default React.memo(TrashIcon);
